"use strict";var _interopRequireDefault = require("D:\\work\\svn\\\u5BB6\u7528\u540E\u53F0\\branches\\20240430-1.5.0\\node_modules\\@babel\\runtime/helpers/interopRequireDefault");Object.defineProperty(exports, "__esModule", { value: true });exports.default = void 0;require("core-js/modules/es6.function.name");

























































































































var _user = require("@/utils/user");
var _formatter = require("@/utils/formatter");
var _aliOss = _interopRequireDefault(require("@/utils/aliOss")); //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = { data: function data() {return { tableData: [], // 列表数据
      organizationList: [], robotId: '', insId: '', newadd: false, modOrg: false, title: '', searchData: { sn: '', insId: '', page: 1, // 页码条数
        rows: 10 }, pageData: { page: 1, rows: 10, total: 0, pages: 1 }, addData: { id: '', sn: '', icon: '', name: '' }, rules: { name: [{ required: true, message: '请输入名称', trigger: 'blur' }], icon: [{ required: true, message: '请上传图片', trigger: 'blur' }], sn: [{ required: true, message: '请输入序列号', trigger: 'blur' }] }, // 表格列
      tableColumns: [{ prop: 'sn', label: '序列号', isShow: true }, { prop: 'name', label: '名称', isShow: true }, { prop: 'createTime', label: '创建时间', formatter: _formatter.dateFormatter, isShow: true }], defaultProps: { children: 'child', label: 'insName' } };}, mounted: function mounted() {var self = this;var orgId = self.$route.query.orgId;if (orgId) {self.searchData.insId = orgId;}self.init();}, methods: { init: function init() {var self = this;self.getData('/api/temi/company/robot', self.searchData, function (res) {self.tableData = res.list;self.pageData.page = res.pageNum;self.pageData.total = res.total;});}, checkPermission: _user.checkPermission, resetFun: function resetFun() {// 重置
      this.searchData.sn = '';this.init();}, searchFun: function searchFun() {// 搜索事件
      this.searchData.page = 1;this.init();}, handleSizeChange: function handleSizeChange(val) {// 分页条数
      this.searchData.rows = val;this.searchData.page = 1;this.init();}, handleCurrentChange: function handleCurrentChange(val) {// 分页页码
      this.searchData.page = val;this.init();}, fnUploadRequest: function fnUploadRequest(option) {var path = 'robot/news';_aliOss.default.ossUploadFile(option, path);}, addFun: function addFun() {// 新增
      this.title = '新增';this.newadd = true;}, closeDiglog: function closeDiglog() {// 关闭弹出层
      this.$refs['addForm'].resetFields();this.cleanData();this.newadd = false;this.newadd2 = false;}, beforeRemove: function beforeRemove(file, fileList) {var fileName = file.name;var confirm = '确定移除' + fileName + '？';return this.$confirm(confirm);}, handleOnRemove: function handleOnRemove(file, fileList) {this.addData.icon = '';this.$message('移除' + file.name + '成功');}, onsuccess: function onsuccess(res) {
      var iconUrl = 'https://cdn-tech.cozzia.com.cn/' + res.name;
      this.addData.icon = iconUrl;
    },
    updateMenu: function updateMenu(item) {// 修改操作
      this.title = '修改';
      var self = this;
      self.newadd = true;
      self.addData = {
        id: item.id,
        name: item.name,
        sn: item.sn,
        icon: item.icon };

    },
    onSubmit: function onSubmit() {// 新增提交操作
      var self = this;
      self.$refs.addForm.validate(function (valid) {
        if (valid) {
          self.postData('/api/temi/robot', self.addData, function (res) {
            self.$message({
              message: '添加成功!',
              type: 'success' });

            self.onCencal();
            self.searchData.page = 1;
            self.init();
          });
        } else {
          return false;
        }
      });
    },
    delMenu: function delMenu(delId) {// 删除操作
      var self = this;
      self.$confirm('确定删除该记录吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true }).
      then(function () {
        self.delData('/api/temi/robot?id=' + delId, {}, function (res) {
          self.$message({
            message: '删除成功!',
            type: 'success' });

          self.searchData.page = 1;
          self.init();
        });
      }).catch(function () {});
    },
    onCencal: function onCencal() {// 关闭弹出框
      this.$refs.addForm.resetFields();
      this.cleanData();
      this.newadd = false;
    },
    cleanData: function cleanData() {// 清理输入的数据
      this.addData = {
        id: '',
        title: '',
        longContent: '',
        orderNum: 0,
        icon: '' };

    },
    openOrgDialog: function openOrgDialog(robotId) {
      var self = this;
      self.robotId = robotId;
      self.getIns(robotId);
      self.getOrganziationList();
      self.modOrg = true;
    },
    closeOrgDialog: function closeOrgDialog() {
      this.modOrg = false;
      this.insId = '';
      this.robotId = '';
      this.$refs.orgTree.setCheckedKeys([]);
    },
    checkFn: function checkFn(node, data) {
      var currKey = node.id;
      this.$refs.orgTree.setCheckedKeys([currKey]);
      this.insId = currKey;
    },
    getIns: function getIns(robot) {
      var self = this;
      self.getData('api/temi/robot/ins/' + robot, {}, function (res) {
        console.log(res);
        if (res.robotInsInfo !== null) {
          self.insId = res.robotInsInfo.insId;
          if (self.insId !== '') {
            self.$refs.orgTree.setCheckedKeys([self.insId]);
          }
        }
      });
    },
    bandIns: function bandIns() {// 新增提交操作
      var self = this;
      var ins = {
        insId: self.insId,
        robotId: self.robotId };

      if (ins.insId === '' || ins.robotId === '') {
        self.$message({ message: '请选择组织', type: 'error' });
        return false;
      }
      self.postData('/api/temi/robot/ins/' + ins.robotId, ins, function (res) {
        self.$message({
          message: '添加成功!',
          type: 'success' });

        self.closeOrgDialog();
        self.searchData.page = 1;
        self.init();
      });
    } } };exports.default = _default;